import _ from 'lodash';
import React, { Component, cloneElement } from 'react';
import { WppTable, WppTableBody, WppTableBodyRow, WppTableBodyCell, WppInlineMessage, WppTableHeader, WppTableHeaderRow, WppTableHeaderCell } from 'buildingBlocks';

type TableHeaderProps = {
  headers: Array<{ value: string, text: string }>
  sortBy: string
  onClick: Function
};

const TableHeader: React.FC<TableHeaderProps> = ({ headers, sortBy, onClick }: TableHeaderProps): React.ReactElement => (
  <WppTableHeader>
    <WppTableHeaderRow>
      {(_.map(headers, (header) => (
        <WppTableHeaderCell
          key={header.value}
          onClick={() => onClick && onClick(header.value)}
          enableSort
          activeSortColumn={_.isEqual(sortBy, header.value)}
          title={header.text}
        />
      )))}
    </WppTableHeaderRow>
  </WppTableHeader>
);

/* eslint-disable react/no-unused-prop-types */
type Props = {
  headers: Array<{ text: string, value: string }>
  sortBy: string
  sortDescending: boolean
  id: string
  children: JSX.Element
  onHeaderClick: Function
  customSort?: Function
  body?: Array<unknown>
  noDataMsg?: string
};
/* eslint-enable */

type State = {
  data: Array<unknown>
};

class MetricsTable extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { data: [] };
  }

  UNSAFE_componentWillMount() {
    this.setSortedBody(this.props);
  }

  UNSAFE_componentWillReceiveProps(newProps: Props) {
    const newVal = _.pick(newProps, ['sortBy', 'body', 'sortDescending']);
    const oldVal = _.pick(this.props, ['sortBy', 'body', 'sortDescending']);
    if (!_.isEqual(oldVal, newVal)) {
      this.setSortedBody(newProps);
    }
  }

  setSortedBody({
    body, sortBy, sortDescending, customSort,
  }: Props) {
    let data;
    if (customSort) {
      data = customSort(body, sortBy, sortDescending);
    } else if (body) {
      data = [...body];
      if (sortBy) {
        data = _.sortBy(data, sortBy);
        if (sortDescending) {
          data = _.reverse(data);
        }
      }
    }

    this.setState({
      data,
    });
  }

  render() {
    const {
      id,
      headers,
      sortBy,
      noDataMsg,
      onHeaderClick,
      children,
    } = this.props;

    return (
      <WppTable id={id}>
        <TableHeader
          headers={headers}
          sortBy={sortBy}
          onClick={onHeaderClick}
        />
        {
          _.isEmpty(this.state.data) ? (
            <WppTableBody>
              <WppTableBodyRow>
                <WppTableBodyCell colSpan={_.size(headers)}>
                  <WppInlineMessage size="s" type="warning" message={noDataMsg || 'This table currently has no analytics data to display.'} />
                </WppTableBodyCell>
              </WppTableBodyRow>
            </WppTableBody>
          ) : cloneElement(children, { headers, ...this.state })
        }
      </WppTable>
    );
  }
}

export default MetricsTable;
